// import { MUNIO } from '$lib/munio';
// import { getAuth } from 'firebase/auth';
// import type { Auth } from 'firebase/auth';
// import { browser } from '$app/environment';
// import { initializeApp } from 'firebase/app';
// import type { FirebaseApp } from 'firebase/app';
// import type { Firestore } from 'firebase/firestore';

// export let db: Firestore;
// export let app: FirebaseApp;
// export let auth: Auth;

// const firebaseConfig = {
//     // projectId: "munio-id",
//     // measurementId: "G-7T71RL1JSH",
//     // messagingSenderId: "818062913459",
//     // storageBucket: "munio-id.appspot.com",
//     // authDomain: "munio-id.firebaseapp.com",
//     // appId: "1:818062913459:web:a9eda4f1ce27055143e5c6",
//     // apiKey: "AIzaSyAH1lkif2OXUoj683VM97hcX0h9HO7LA8o",
//     projectId: "munio-id",
//     measurementId: "G-7T71RL1JSH",
//     messagingSenderId: "818062913459",
//     storageBucket: "munio-id.appspot.com",
//     authDomain: "munio-id.firebaseapp.com",
//     appId: "1:818062913459:web:a9eda4f1ce27055143e5c6",
//     apiKey: "AIzaSyAH1lkif2OXUoj683VM97hcX0h9HO7LA8o",
// };

// export const initializeFirebase = async () => {
//     // const originUrl = window.location.origin
//     // MUNIO.initMunio(await MUNIO.getClientKey(originUrl));
//     // const dataConfigFirebase = await MUNIO.getFirebaseAppServiceAccount()

//     if (!browser) {
//         throw new Error("Can't use the Firebase client on the server.");
//     }

//     if (!app) {
//         app = initializeApp(firebaseConfig);
//         auth = getAuth(app);
//     }
// };

import { MUNIO } from "$lib/munio";
import { getAuth } from "firebase/auth";
import type { Auth } from "firebase/auth";
import { browser } from "$app/environment";
import { initializeApp } from "firebase/app";
import type { FirebaseApp } from "firebase/app";
import type { Firestore } from "firebase/firestore";

export let db: Firestore;
export let app: FirebaseApp;
export let auth: Auth;

let firebaseConfig: any;

export const initializeFirebase = async () => {
    try {
        const originUrl = window.location.origin;
        MUNIO.initMunio(originUrl);
        const dataConfigFirebase = await MUNIO.getFirebaseAppServiceAccount();
        firebaseConfig = dataConfigFirebase?.data;
        // {
        //     projectId: "munio-id",
        //     measurementId: "G-7T71RL1JSH",
        //     messagingSenderId: "818062913459",
        //     storageBucket: "munio-id.appspot.com",
        //     authDomain: "munio-id.firebaseapp.com",
        //     appId: "1:818062913459:web:a9eda4f1ce27055143e5c6",
        //     apiKey: "AIzaSyAH1lkif2OXUoj683VM97hcX0h9HO7LA8o",
        // }

        if (!dataConfigFirebase?.data) {
            throw new Error(
                "Failed to retrieve Firebase app service account data.",
            );
        }

        if (!browser) {
            throw new Error("Can't use the Firebase client on the server.");
        }

        if (!app) {
            app = initializeApp(firebaseConfig);
            auth = getAuth(app);
        }
    } catch (error) {
        throw new Error(
            "Failed to retrieve Firebase app service account data.",
        );
    }
};
